import { Component, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { Store } from "@ngrx/store";
import { CarouselComponent } from '../carousel/carousel.component';
import { OnboardingService } from '../../services/onboarding.service';
import {
  onboardingPopupDismissedEvent,
  onboardingPopupNextEvent,
  onboardingPopupPrevEvent,
  onboardingPopupShowEvent
} from '../../tracking/events';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromAuth from "../../../../store/auth";
import { IFeatureResponse } from '../../models/IFeatureResponse';

// Features published from this date on have an @2x image next to each uploaded one; older ones don't.
const RETINA_IMAGES_SINCE = '2026-11-02';

@Component({
    selector: 'app-onboarding-overlay',
    templateUrl: './onboarding-overlay.component.html',
    styleUrls: ['./onboarding-overlay.component.scss'],
    standalone: false
})
export class OnboardingOverlayComponent implements OnInit {
  @ViewChild(CarouselComponent) carousel: CarouselComponent;
  // Each image as a srcset, so high-density screens (phones, Retina displays) pick the @2x version.
  features$ = this.store.select(fromAuth.selectFeatures).pipe(
    map(features => features?.map(feature => ({ ...feature, srcSets: this.srcSets(feature) }))),
  );

  constructor(
    private onboarding: OnboardingService,
    private tracking: TrackingService,
    private store: Store<{ auth: fromAuth.AuthState }>,
  ) {}

  private srcSets(feature: IFeatureResponse): string[] {
    if (!feature.startDate || feature.startDate < RETINA_IMAGES_SINCE) return feature.urls;
    // intro-1.png -> intro-1@2x.png (any query string, e.g. a SAS token, stays at the end).
    return feature.urls.map(url =>
      url.includes('@2x.') ? url : `${url} 1x, ${url.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '@2x$1$2')} 2x`,
    );
  }

  ngOnInit() {
    this.tracking.track(onboardingPopupShowEvent());
  }

  dismiss() {
    this.onboarding.dismiss();
    this.tracking.track(onboardingPopupDismissedEvent());
  }

  next() {
    this.carousel.next(false);
    this.tracking.track(onboardingPopupNextEvent());
  }

  prev() {
    this.carousel.prev(false);
    this.tracking.track(onboardingPopupPrevEvent());
  }

  trackPanNext() {
    this.tracking.track(onboardingPopupNextEvent());
  }

  trackPanPrev() {
    this.tracking.track(onboardingPopupPrevEvent());
  }
}
